import { render, staticRenderFns } from "./oportunidade.vue?vue&type=template&id=edde21ae"
import script from "./oportunidade.vue?vue&type=script&lang=js"
export * from "./oportunidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports